import { faArrowsTurnToDots, faBoxOpen, faComment, faFlask, faMagnifyingGlass, faNoteSticky, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { use, useContext, useEffect, useState, useMemo } from 'react';
import { Accordion, Spinner } from 'react-bootstrap';

import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import { UserPreferencesContext } from '../../../Contexts/UserPreferencesContext';
import { QualityColumnType } from '../../../Types/LotDetailQuality';
import { Section } from '../../../Types/Section';
import GradingCommentsSection from '../LotDetailsComponents/GradingCommentsSection';
import LabResultsSection from '../LotDetailsComponents/LabResultsSection';
import PackagesSection from '../LotDetailsComponents/PackagesSection/PackagesSection';
import QIRSection_QIRMS from '../LotDetailsComponents/QIRSection_QIRMS';
import QualitiesSection from '../LotDetailsComponents/QualitiesSection';
import LotDetailSummary from '../LotDetailsComponents/Summary';
import WarningsSection from '../LotDetailsComponents/WarningsSection';
import { LotDetailSection } from '../LotDetailSection';
import { SectionNavigation } from '../SectionNavigation';
import RelatedLotsSection from '../LotDetailsComponents/RelatedLotsSection';

function LotDetails_BTBU() {

    const { lotDetail } = useContext(LotDetailContext);
    const { userPreferences, loading: userPreferencesLoading, setActiveSections } = use(UserPreferencesContext);
    const [loading, setLoading] = useState(false);

    const qualityColumns: QualityColumnType[] = useMemo(()=> [
        "Name",
        "LBMLab",
        "Units",
        "LBMLabMin",
        "LBMLabMax",
        "LRL",
        "URL",
        "Target",
        "displayOrder",
    ], []);

    const sections: Section[] = [
        { name: 'warnings', title: 'LotDetails.Warnings.Title', icon: faTriangleExclamation, component: <WarningsSection /> },
        { name: 'relatedLots', title: 'LotDetails.RelatedLots.Title', icon: faArrowsTurnToDots, component: <RelatedLotsSection /> },
        { name: 'qualities', title: 'LotDetails.Qualities.Title', icon: faMagnifyingGlass, component: <QualitiesSection customQualityColumns={qualityColumns} /> },
        { name: 'packages', title: 'LotDetails.Packages.Title', titleSuffix: `${lotDetail.packages.length}`, icon: faBoxOpen, component: <PackagesSection packagesCanBeEdited={false} /> },
        { name: 'QIRMSqirs', title: 'LotDetails.QIRs.Title', icon: faNoteSticky, component: <QIRSection_QIRMS showCreateQIRButton={true} /> },
        { name: 'labresults', title: 'LotDetails.LabResults.Title', titleSuffix: `${lotDetail.labResults.length}`, icon: faFlask, component: <LabResultsSection /> },
        { name: 'gradingcomments', title: 'LotDetails.GradingComments.Title', icon: faComment, component: <GradingCommentsSection /> },
    ];

    const [defaultActiveSections, setDefaultActiveSections] = useState(sections.map(section => section.name));
    useEffect(() => {
        if (userPreferences?.lotDetail?.activeSections) {
            setDefaultActiveSections(userPreferences?.lotDetail?.activeSections);
        }
    }, [userPreferences?.lotDetail?.activeSections]);

    if (userPreferencesLoading) {
        return (
            <div className="d-flex justify-content-center mb-3">
                <Spinner animation="border" />
            </div>
        );
    }

    return (lotDetail &&
        <>
            <LotDetailSummary setLoading={setLoading} />

            <SectionNavigation sections={sections} />

            <Accordion activeKey={defaultActiveSections} onSelect={(eventKey) => setActiveSections(eventKey as string[])} alwaysOpen className="mb-2">
                {sections.map(section =>
                    <LotDetailSection
                        key={section.name}
                        name={section.name}
                        icon={section.icon}
                        title={section.title}
                        titleSuffix={section.titleSuffix}
                        component={section.component} />)
                }
            </Accordion>
        </>
    );
}

export default LotDetails_BTBU;